import { render, staticRenderFns } from "./IconSvgEvents.vue?vue&type=template&id=40d551f0&scoped=true&"
import script from "./IconSvgEvents.vue?vue&type=script&lang=js&"
export * from "./IconSvgEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d551f0",
  null
  
)

export default component.exports